<template>
  <!-- 充值卡操作记录 -->
  <el-dialog title="明细" :visible="visible" @close="close" class="card-history-dialog">
    <el-form :inline="true" @submit.native.prevent :model="searchForm">
      <el-form-item>
        <el-select
          v-model="searchForm.fin_type"
          @change="fetchList"
          style="width:120px">
          <el-option label="全部类型" value="全部类型"></el-option>
          <el-option label="收入" value="收入"></el-option>
          <el-option label="支出" value="支出"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      stripe
      border
      :row-class-name="tableRowClassName"
      style="width:100%">
      <el-table-column
        prop="card_no"
        label="卡号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="fin_type"
        label="类型"
        width="60">
      </el-table-column>
      <el-table-column
        prop="oper_type"
        label="摘要"
        width="110">
      </el-table-column>
      <el-table-column
        prop="oper_money"
        label="金额"
        width="70">
      </el-table-column>
      <el-table-column
        prop="pay_money"
        label="实收/实付"
        width="90">
      </el-table-column>
      <el-table-column
        prop="oper_time"
        label="操作时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="oper_name"
        label="操作人"
        width="70">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="350">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageChange"
      :current-page="currentPage"
      :page-sizes="[15, 50, 100, 500]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <div slot="footer" class="dialog-footer">
      <el-button type="success" @click="excel" :loading="exporting">导出到excel</el-button>
      <el-button @click="close">关闭窗口</el-button>
    </div>
  </el-dialog>
</template>

<script>
import qs from 'qs'
export default {
  props: {
    cardNo: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    user: Object
  },
  data () {
    return {
      list: [],
      searchForm: {
        fin_type: [1,10].indexOf(this.user.group_id) >= 0 ? '收入' : '全部类型'
      },
      loading: false,
      currentPage: 1,
      pageSize: 15,
      total: 0,
      exporting: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.fetchList()
      }
    }
  },
  methods: {
    fetchList () {
      let ps = { card_no: this.cardNo }
      if (this.searchForm.fin_type !== '全部类型') {
        ps.fin_type = this.searchForm.fin_type
      }
      if (this.pageSize > 0) {
        ps.start = (this.currentPage - 1) * this.pageSize
        ps.limit = this.pageSize
      }
      this.loading = true
      this.$http.get('/dbapi/card_history', {
        params: ps
      }).then(response => {
        if (response.data.success) {
          this.list = response.data.list
          this.total = response.data.total
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    pageChange (val) {
      this.currentPage = val
      this.fetchList()
    },
    pageSizeChange (val) {
      this.pageSize = val
      this.fetchList()
    },
    excel () {
      let params = { card_no: this.cardNo }
      if (this.searchForm.fin_type !== '全部类型') {
        params.fin_type = this.searchForm.fin_type
      }
      this.exporting = true
      this.$http.get('/dbapi/excel/card_history', { params }).then(response => {
        this.exporting = false
        if (response.data.success) {
          this.$alert('导出成功,点击下载文件', '导出成功', {
            confirmButtonText: '下载文件',
            callback: action => {
              window.open(response.data.url)
            }
          })
        } else {
          this.$message({ type: 'error', message: '导出失败,' + response.data.message })
        }
      })
    },
    close () {
      this.$emit('close')
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.fin_type === '收入') {
        return 'row-green'
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
.card-history-dialog .el-dialog__body {
  padding-top: 0!important;
}
.card-history-dialog .el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/card/CardHistoryDialog.vue